import { render, staticRenderFns } from "./AppUploadFile.vue?vue&type=template&id=5649bf11&scoped=true&"
import script from "./AppUploadFile.vue?vue&type=script&lang=js&"
export * from "./AppUploadFile.vue?vue&type=script&lang=js&"
import style0 from "./AppUploadFile.vue?vue&type=style&index=0&id=5649bf11&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5649bf11",
  null
  
)

export default component.exports